import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Logo from '../../components/feature/Logo';
import PartnershipTeaser from './components/PartnershipTeaser';

export default function Landing() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-advance slider
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleUploadClick = () => {
    navigate('/upload-knowledge');
  };

  const handleDashboardClick = () => {
    navigate('/dashboard');
  };

  const slides = [
    {
      title: 'Screenshot hochladen & sofort Hilfe erhalten',
      description: 'Fotografiere deine Aufgabe und erhalte Schritt-für-Schritt Erklärungen - 24/7 verfügbar',
      image: 'https://public.readdy.ai/ai/img_res/395da7c70544430621725f5cd40f9431.jpg',
      cta: 'Jetzt kostenlos testen',
      ctaLink: '/upload-knowledge',
      badge: 'KI-gestützte Analyse'
    },
    {
      title: 'Frag den Lehrer - Stelle beliebige Fragen',
      description: 'Erhalte strukturierte Antworten mit Erklärungen, Übungen und Quiz zu jedem Thema',
      image: 'https://readdy.ai/api/search-image?query=teenage%20boy%20student%20age%20sixteen%20using%20laptop%20asking%20questions%20online%20learning%20happy%20curious%20expression%20blonde%20hair%20light%20skin%20tone%20bright%20study%20space%20natural%20daylight%20educational%20technology%20interactive%20learning&width=1920&height=1080&seq=hero-ask-teacher&orientation=landscape',
      cta: 'Frage stellen',
      ctaLink: '/ask-teacher',
      badge: 'NEU: Interaktives Lernen'
    },
    {
      title: 'Lernen per Telegram - Überall & Jederzeit',
      description: 'Nutze Learnsnap direkt in Telegram! Im Bus, in der Pause oder zu Hause - stelle Fragen wann und wo du willst',
      image: 'https://readdy.ai/api/search-image?query=teenage%20boy%20student%20age%20fourteen%20sitting%20in%20school%20bus%20holding%20smartphone%20using%20telegram%20messenger%20app%20happy%20smiling%20expression%20brown%20hair%20light%20skin%20tone%20bright%20natural%20daylight%20through%20bus%20window%20modern%20mobile%20learning%20on%20the%20go%20educational%20technology&width=1920&height=1080&seq=hero-telegram-mobile&orientation=landscape',
      cta: 'Telegram Bot starten',
      ctaLink: 'https://t.me/LearnSnapBot',
      badge: 'NEU: Mobiles Lernen'
    },
    {
      title: 'Personalisierte Testvorbereitung',
      description: 'Erstelle individuelle Testpläne für deine Schulaufgaben und Prüfungen',
      image: 'https://readdy.ai/api/search-image?query=young%20girl%20student%20exactly%20ten%20years%20old%20fourth%20grade%20elementary%20school%20sitting%20at%20desk%20with%20smartphone%20in%20hands%20learning%20with%20mobile%20app%20excited%20happy%20joyful%20expression%20brown%20hair%20ponytail%20light%20skin%20tone%20bright%20colorful%20study%20room%20natural%20daylight%20educational%20technology%20mobile%20learning%20digital%20education&width=1920&height=1080&seq=girl-10yo-mobile-learning-2025-v3&orientation=landscape',
      cta: 'Testplan erstellen',
      ctaLink: '/auth/register',
      badge: 'Adaptives Lernen'
    },
    {
      title: 'Berufliche Weiterbildung leicht gemacht',
      description: 'Auch für Erwachsene: Lerne neue Fähigkeiten für deinen Beruf - flexibel und effektiv',
      image: 'https://readdy.ai/api/search-image?query=professional%20adult%20woman%20age%20thirty%20working%20on%20laptop%20learning%20new%20skills%20happy%20confident%20expression%20business%20casual%20attire%20modern%20bright%20office%20space%20natural%20daylight%20professional%20development%20continuing%20education%20career%20growth&width=1920&height=1080&seq=hero-adult-learning&orientation=landscape',
      cta: 'Weiterbildung starten',
      ctaLink: '/auth/register',
      badge: 'Für alle Altersgruppen'
    }
  ];

  const features = [
    {
      icon: 'ri-database-2-line',
      title: 'KI-gestützte Wissensdatenbank',
      description: 'Lade Screenshots deiner Lehrbücher hoch und baue deine persönliche Wissensdatenbank auf. Unsere KI nutzt diese, um personalisierte Übungsfragen und Lernpläne zu erstellen.',
      color: 'bg-gradient-to-br from-teal-500 to-emerald-500'
    },
    {
      icon: 'ri-book-mark-line',
      title: 'Transparente Quellenangaben',
      description: 'Jede KI-Erklärung enthält präzise Quellenangaben aus deinen hochgeladenen Materialien. So kannst du jede Antwort nachprüfen und lernst gleichzeitig, mit Quellen zu arbeiten.',
      color: 'bg-gradient-to-br from-indigo-500 to-violet-500'
    },
    {
      icon: 'ri-thumb-up-line',
      title: 'Feedback-System für KI-Qualität',
      description: 'Bewerte jede KI-Erklärung mit Daumen hoch/runter. Dein Feedback hilft uns, die Erklärungen kontinuierlich zu verbessern und noch verständlicher zu machen.',
      color: 'bg-gradient-to-br from-violet-500 to-purple-500'
    },
    {
      icon: 'ri-notification-line',
      title: 'Intelligente Erinnerungen',
      description: 'Erhalte Browser-Benachrichtigungen für anstehende Tests, Lernziele und deinen Lernstreak. Verpasse nie wieder eine wichtige Lernsession!',
      color: 'bg-gradient-to-br from-indigo-500 to-violet-500'
    },
    {
      icon: 'ri-time-line',
      title: '24/7 Verfügbarkeit',
      description: 'Lerne wann und wo du willst. Unsere KI-Nachhilfe ist rund um die Uhr für dich da - keine Terminvereinbarungen, keine Wartezeiten.',
      color: 'bg-gradient-to-br from-orange-500 to-amber-500'
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Bezahlbar für jeden',
      description: 'Hochwertige Nachhilfe muss nicht teuer sein. Mit Learnsnap bekommst du professionelle Unterstützung zu einem Bruchteil der üblichen Kosten.',
      color: 'bg-gradient-to-br from-teal-500 to-emerald-500'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Intelligente Wiederholung',
      description: 'Unser adaptives Lernsystem erkennt, welche Themen du noch üben musst und wiederholt diese automatisch zum optimalen Zeitpunkt.',
      color: 'bg-gradient-to-br from-orange-500 to-amber-500'
    }
  ];

  const subjects = [
    { name: 'Mathematik', icon: 'ri-calculator-line', color: 'from-teal-500 to-emerald-500' },
    { name: 'Deutsch', icon: 'ri-book-open-line', color: 'from-teal-500 to-emerald-500' },
    { name: 'Englisch', icon: 'ri-global-line', color: 'from-orange-500 to-amber-500' },
    { name: 'Biologie', icon: 'ri-leaf-line', color: 'from-teal-500 to-emerald-500' },
    { name: 'Physik', icon: 'ri-flashlight-line', color: 'from-teal-500 to-emerald-500' },
    { name: 'Chemie', icon: 'ri-test-tube-line', color: 'from-orange-500 to-amber-500' }
  ];

  const steps = [
    {
      number: '01',
      title: 'Registrieren',
      description: 'Erstelle dein kostenloses Konto in wenigen Sekunden',
      icon: 'ri-user-add-line'
    },
    {
      number: '02',
      title: 'Screenshots hochladen',
      description: 'Fotografiere deine Lehrbuchseiten und lade sie hoch',
      icon: 'ri-camera-line'
    },
    {
      number: '03',
      title: 'KI analysiert',
      description: 'Unsere KI erkennt Inhalte und erstellt Lernmaterial',
      icon: 'ri-sparkling-line'
    },
    {
      number: '04',
      title: 'Lernen & Üben',
      description: 'Starte deine personalisierte Lernsession',
      icon: 'ri-lightbulb-line'
    }
  ];

  const testimonials = [
    {
      name: 'Sarah M.',
      grade: '10. Klasse',
      text: 'Seit ich Learnsnap nutze, haben sich meine Noten in Mathe von 4 auf 2 verbessert. Die KI erklärt alles so, dass ich es endlich verstehe!',
      avatar: 'https://readdy.ai/api/search-image?query=friendly%20teenage%20girl%20student%20smiling%20portrait%20simple%20clean%20background%20natural%20daylight%20professional%20photo&width=100&height=100&seq=testimonial1&orientation=squarish'
    },
    {
      name: 'Lukas K.',
      grade: '12. Klasse',
      text: 'Die 24/7 Verfügbarkeit ist perfekt für mich. Ich lerne oft spät abends und kann jederzeit auf die KI-Nachhilfe zugreifen.',
      avatar: 'https://readdy.ai/api/search-image?query=confident%20teenage%20boy%20student%20smiling%20portrait%20simple%20clean%20background%20natural%20daylight%20professional%20photo&width=100&height=100&seq=testimonial2&orientation=squarish'
    },
    {
      name: 'Emma W.',
      grade: '9. Klasse',
      text: 'Endlich kann ich mir Nachhilfe leisten! Meine Eltern sind begeistert vom Preis und ich von den Ergebnissen.',
      avatar: 'https://readdy.ai/api/search-image?query=happy%20teenage%20girl%20student%20with%20glasses%20smiling%20portrait%20simple%20clean%20background%20natural%20daylight%20professional%20photo&width=100&height=100&seq=testimonial3&orientation=squarish'
    }
  ];

  const stats = [
    { number: '10.000+', label: 'Aktive Schüler' },
    { number: '500.000+', label: 'Gelöste Aufgaben' },
    { number: '95%', label: 'Zufriedenheit' },
    { number: '24/7', label: 'Verfügbar' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                "@id": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/#website`,
                "url": import.meta.env.VITE_SITE_URL || 'https://learnsnap.online',
                "name": "LearnSnap",
                "description": "KI-gestützte Lernplattform für Schüler und Studenten – Screenshot hochladen, KI erklärt Lösungswege Schritt für Schritt. Sofortige Nachhilfe, Datenschutz &amp; Qualitätssicherung.",
                "inLanguage": "de",
                "publisher": { "@id": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/#organization` }
              },
              {
                "@type": "Organization",
                "@id": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/#organization`,
                "name": "Future Now UG",
                "legalName": "Future Now UG",
                "url": import.meta.env.VITE_SITE_URL || 'https://learnsnap.online',
                "email": "info@future-now.online",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Max-Planck-Str. 4",
                  "addressLocality": "Aschheim",
                  "postalCode": "85609",
                  "addressCountry": "DE"
                }
              },
              {
                "@type": "SoftwareApplication",
                "name": "LearnSnap",
                "applicationCategory": "EducationApplication",
                "operatingSystem": "Web",
                "url": import.meta.env.VITE_SITE_URL || 'https://learnsnap.online',
                "description": "KI-gestützte Nachhilfe: Screenshot hochladen, KI erklärt Lösungswege Schritt für Schritt. Testvorbereitung, Wissensdatenbank und Fortschritts-Tracking.",
                "inLanguage": "de",
                "offers": {
                  "@type": "Offer",
                  "price": "9.99",
                  "priceCurrency": "EUR",
                  "availability": "https://schema.org/InStock"
                },
                "provider": {
                  "@id": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/#organization`
                }
              }
            ]
          })
        }}
      />
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Logo size="md" showText={true} textColor={isScrolled ? 'text-slate-900' : 'text-white'} />
            <div className="hidden md:flex items-center gap-8">
              <a href="#features" className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-slate-700' : 'text-white'}`}>Funktionen</a>
              <a href="#how-it-works" className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-slate-700' : 'text-white'}`}>So funktioniert's</a>
              <a href="#subjects" className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-slate-700' : 'text-white'}`}>Fächer</a>
              <a href="#testimonials" className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-slate-700' : 'text-white'}`}>Erfahrungen</a>
              <a href="#career" className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-slate-700' : 'text-white'}`}>Karriere</a>
              <Link
                to="/partnerschaft"
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 border rounded-lg px-3 py-1.5 ${isScrolled ? 'text-teal-700 border-teal-300 bg-teal-50 hover:bg-teal-100' : 'text-white border-white/40 bg-white/10 hover:bg-white/20'}`}
              >
                <i className="ri-handshake-line text-base"></i>
                Kooperation / White-Label
              </Link>
              <Link
                to="/pricing"
                className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-slate-700' : 'text-white'}`}
              >
                Preise
              </Link>
              <Link
                to="/auth/login"
                className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap"
              >
                Schüler Login
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section with Slider */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Slider Container */}
        <div className="absolute inset-0">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url('${slide.image}')` }}
              ></div>
              
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
            </div>
          ))}
        </div>
        
        {/* Content */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-full text-white mb-8">
            <i className="ri-shield-check-line"></i>
            <span className="text-sm font-medium">{slides[currentSlide].badge}</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight min-h-[180px] flex items-center justify-center">
            {slides[currentSlide].title}
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto min-h-[80px] flex items-center justify-center">
            {slides[currentSlide].description}
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link
              to={slides[currentSlide].ctaLink}
              className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-8 py-4 rounded-lg font-semibold text-base hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap"
            >
              {slides[currentSlide].cta}
            </Link>
            {/* Universeller "Jetzt registrieren" Button für alle Slides */}
            <Link
              to="/auth/register"
              className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold text-base hover:shadow-2xl transition-all border-2 border-teal-500 cursor-pointer whitespace-nowrap"
            >
              Jetzt registrieren
            </Link>
          </div>

          {/* Slider Navigation Dots */}
          <div className="flex items-center justify-center gap-3">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`transition-all cursor-pointer ${
                  index === currentSlide
                    ? 'w-12 h-3 bg-white rounded-full'
                    : 'w-3 h-3 bg-white/50 rounded-full hover:bg-white/75'
                }`}
                aria-label={`Slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Slider Controls */}
          <div className="absolute left-4 right-4 top-1/2 -translate-y-1/2 flex items-center justify-between pointer-events-none">
            <button
              onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
              className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all pointer-events-auto cursor-pointer"
              aria-label="Previous slide"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>
            <button
              onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
              className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all pointer-events-auto cursor-pointer"
              aria-label="Next slide"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-play-circle-line"></i>
              <span>Learnsnap in Aktion</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Sieh dir an, wie Learnsnap funktioniert
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Entdecke in diesem Video, wie einfach und effektiv das Lernen mit Learnsnap ist
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-teal-100">
              {/* Sound Notice */}
              <div className="absolute top-4 left-4 z-10 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-teal-200">
                <div className="flex items-center gap-2">
                  <i className="ri-volume-up-line text-teal-600 text-lg"></i>
                  <span className="text-sm font-medium text-slate-900">Ton einschalten für beste Erfahrung</span>
                </div>
              </div>

              {/* HeyGen Video Embed */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://app.heygen.com/embedded-player/7663255eff4949ec94336df251f42cd5"
                  title="Learnsnap Demo Video"
                  frameBorder="0"
                  allow="encrypted-media; fullscreen;"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Video Info */}
            <div className="mt-6 text-center">
              <p className="text-sm text-slate-600">
                <i className="ri-information-line text-teal-600 mr-1"></i>
                Klicke auf das Video, um es zu starten und den Ton einzuschalten.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Badges Section */}
      <section className="bg-white border-y border-gray-200 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {/* DSGVO Badge */}
            <div className="flex items-center justify-center gap-3 p-4">
              <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-blue-600 text-2xl"></i>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900 text-sm">DSGVO-konform</p>
                <p className="text-xs text-gray-600">EU-Datenschutz</p>
              </div>
            </div>

            {/* SSL Badge */}
            <div className="flex items-center justify-center gap-3 p-4">
              <div className="w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-lock-line text-green-600 text-2xl"></i>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900 text-sm">SSL-verschlüsselt</p>
                <p className="text-xs text-gray-600">Sichere Verbindung</p>
              </div>
            </div>

            {/* Made in Germany Badge */}
            <div className="flex items-center justify-center gap-3 p-4">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-red-600 text-2xl"></i>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900 text-sm">Made in Germany</p>
                <p className="text-xs text-gray-600">Deutsche Server</p>
              </div>
            </div>

            {/* AI Powered Badge */}
            <div className="flex items-center justify-center gap-3 p-4">
              <div className="w-12 h-12 bg-purple-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-robot-2-line text-purple-600 text-2xl"></i>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900 text-sm">KI-gestützt</p>
                <p className="text-xs text-gray-600">OpenAI Technologie</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimer Banner */}
      <div className="bg-slate-100 border-b border-slate-200 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-3 bg-white rounded-full px-6 py-3 border border-slate-200 shadow-sm">
            <i className="ri-shield-check-line text-slate-600 text-lg"></i>
            <p className="text-xs text-slate-600 leading-relaxed">
              <strong>Rechtlicher Hinweis:</strong> Learnsnap ist eine Lernhilfe und garantiert keine Notenverbesserung. Die Inhalte sind datenbezogen und stellen keine professionelle Nachhilfe oder schulische Betreuung dar. Wir übernehmen keine Haftung für die Richtigkeit der Inhalte. Die Nutzung erfolgt auf eigene Verantwortung.
            </p>
          </div>
        </div>
      </div>

      {/* Quick Test Section - Simplified to direct upload */}
      <section className="py-24 bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-200/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-200/30 rounded-full blur-3xl"></div>
        
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4 animate-pulse">
              <i className="ri-flashlight-fill"></i>
              <span>Echte Learnsnap-KI</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Teste Learnsnap jetzt kostenlos!
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Lade Screenshots deiner Notizen hoch und wähle, ob du lernen oder abgefragt werden möchtest. Learnsnap hilft dir, Lösungswege Schritt für Schritt zu verstehen!
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-teal-200">
            <div className="text-center">
              <div className="w-24 h-24 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-upload-cloud-2-line text-white text-5xl"></i>
              </div>
              
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                Starte jetzt mit Learnsnap
              </h3>
              <p className="text-slate-600 mb-8 max-w-2xl mx-auto">
                Lade bis zu 2 Screenshots deiner Lehrbücher oder Notizen hoch. Wähle dann, ob du das Thema erst lernen oder direkt abgefragt werden möchtest. Learnsnap erstellt automatisch passende Inhalte für dich!
              </p>

              <Link
                to="/auth/register"
                className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-camera-line text-2xl"></i>
                <span>Jetzt kostenlos testen</span>
              </Link>

              <p className="text-sm text-slate-500 mt-4">
                Keine Registrierung erforderlich • Sofortige KI-Unterstützung • Bis zu 2 Screenshots
              </p>
            </div>

            {/* How it works */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-12">
              <div className="text-center p-6 bg-slate-50 rounded-xl">
                <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-upload-2-line text-teal-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">1. Hochladen</h4>
                <p className="text-sm text-slate-600">Screenshots oder Dokumente hochladen</p>
              </div>

              <div className="text-center p-6 bg-slate-50 rounded-xl">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-checkbox-circle-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">2. Modus wählen</h4>
                <p className="text-sm text-slate-600">Lernen oder Abfragen auswählen</p>
              </div>

              <div className="text-center p-6 bg-slate-50 rounded-xl">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-magic-line text-emerald-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">3. KI erstellt</h4>
                <p className="text-sm text-slate-600">Learnsnap erstellt passende Inhalte</p>
              </div>

              <div className="text-center p-6 bg-slate-50 rounded-xl">
                <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-brain-line text-violet-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">4. Lernen/Üben</h4>
                <p className="text-sm text-slate-600">Verstehen oder Wissen testen</p>
              </div>
            </div>

            <div className="mt-8 p-6 bg-gradient-to-r from-blue-50 to-teal-50 rounded-xl border-2 border-blue-100">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 mb-2">💡 So funktioniert Learnsnap:</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <p className="font-semibold text-teal-700 mb-2">📚 Lernmodus:</p>
                      <ul className="text-sm text-slate-700 space-y-1">
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-teal-500 mt-0.5"></i>
                          <span>Learnsnap erstellt Lernkarten und Zusammenfassungen</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-teal-500 mt-0.5"></i>
                          <span>Verstehe Lösungswege Schritt für Schritt</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-teal-500 mt-0.5"></i>
                          <span>Perfekt zum ersten Kennenlernen neuer Inhalte</span>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <p className="font-semibold text-blue-700 mb-2">❓ Abfragemodus:</p>
                      <ul className="text-sm text-slate-700 space-y-1">
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-blue-500 mt-0.5"></i>
                          <span>Learnsnap erstellt offene Fragen aus deinen Inhalten</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-blue-500 mt-0.5"></i>
                          <span>Schreibe deine Antworten selbst - keine Multiple Choice!</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-blue-500 mt-0.5"></i>
                          <span>Erhalte intelligentes Feedback (0-100 Punkte)</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-blue-500 mt-0.5"></i>
                          <span>Vergleiche mit Musterantworten und verstehe Lösungswege</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NEW: "Frag den Lehrer" Example Section */}
      <section className="py-24 bg-gradient-to-br from-blue-50 via-indigo-50 to-violet-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4 animate-pulse">
              <i className="ri-sparkling-line"></i>
              <span>NEU: Frag den Lehrer</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              So funktioniert "Frag den Lehrer"
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Stelle beliebige Fragen und erhalte strukturierte, verständliche Antworten mit allem, was du zum Lernen brauchst
            </p>
          </div>

          {/* Example Question */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-blue-200 mb-8">
            <div className="flex items-start gap-4 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-question-line text-white text-3xl"></i>
              </div>
              <div className="flex-1">
                <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-semibold mb-3">
                  <i className="ri-book-line"></i>
                  Mathematik
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2">Beispiel-Frage:</h3>
                <p className="text-lg text-slate-700 italic">"Wie berechne ich die Fläche eines Kreises?"</p>
              </div>
            </div>

            {/* Answer Components */}
            <div className="space-y-6">
              {/* 1. Kurze Erklärung */}
              <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl p-6 border-2 border-teal-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-line text-white text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-slate-900 mb-3">1. Kurze Erklärung</h4>
                    <p className="text-slate-700 leading-relaxed">
                      Die Fläche eines Kreises berechnest du mit der Formel <strong>A = π × r²</strong>. Dabei ist <strong>r</strong> der Radius (der Abstand vom Mittelpunkt zum Rand) und <strong>π</strong> (Pi) ist eine mathematische Konstante mit dem Wert ungefähr 3,14159.
                    </p>
                  </div>
                </div>
              </div>

              {/* 2. Schritt-für-Schritt */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border-2 border-blue-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-list-ordered text-white text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-slate-900 mb-4">2. Schritt-für-Schritt Beispiel</h4>
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">1</div>
                        <div>
                          <p className="text-slate-700"><strong>Gegeben:</strong> Ein Kreis mit Radius r = 5 cm</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">2</div>
                        <div>
                          <p className="text-slate-700"><strong>Formel einsetzen:</strong> A = π × r² = π × 5²</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">3</div>
                        <div>
                          <p className="text-slate-700"><strong>Berechnen:</strong> A = π × 25 = 3,14159 × 25</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">4</div>
                        <div>
                          <p className="text-slate-700"><strong>Ergebnis:</strong> A ≈ 78,54 cm²</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 3. Merksatz/Formel */}
              <div className="bg-gradient-to-r from-violet-50 to-purple-50 rounded-2xl p-6 border-2 border-violet-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-bookmark-line text-white text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-slate-900 mb-3">3. Merksatz / Formel</h4>
                    <div className="bg-white rounded-xl p-4 border-2 border-violet-300">
                      <p className="text-center text-2xl font-bold text-violet-700 mb-2">A = π × r²</p>
                      <p className="text-center text-sm text-slate-600 italic">
                        "Pi mal Radius zum Quadrat - so einfach ist das!"
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 4. Übung */}
              <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-6 border-2 border-orange-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-pencil-line text-white text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-slate-900 mb-3">4. Übung für dich</h4>
                    <div className="bg-white rounded-xl p-4 border border-orange-200">
                      <p className="text-slate-700 mb-2"><strong>Aufgabe:</strong> Berechne die Fläche eines Kreises mit Radius r = 8 cm</p>
                      <p className="text-sm text-slate-500 italic">Tipp: Verwende die Formel A = π × r²</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 5. Mini-Quiz */}
              <div className="bg-gradient-to-r from-pink-50 to-rose-50 rounded-2xl p-6 border-2 border-pink-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-answer-line text-white text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-slate-900 mb-4">5. Mini-Quiz zur Überprüfung</h4>
                    <div className="space-y-3">
                      <div className="bg-white rounded-xl p-4 border border-pink-200">
                        <p className="text-slate-700 font-semibold mb-3">Was bedeutet "r" in der Formel A = π × r²?</p>
                        <div className="space-y-2">
                          <label className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg cursor-pointer hover:bg-pink-50 transition-colors">
                            <input type="radio" name="quiz-example" className="w-4 h-4 text-pink-500" />
                            <span className="text-sm text-slate-700">Der Durchmesser des Kreises</span>
                          </label>
                          <label className="flex items-center gap-3 p-3 bg-green-50 rounded-lg border-2 border-green-500">
                            <input type="radio" name="quiz-example" checked className="w-4 h-4 text-green-500" />
                            <span className="text-sm text-slate-700 font-semibold">✓ Der Radius (Abstand vom Mittelpunkt zum Rand)</span>
                          </label>
                          <label className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg cursor-pointer hover:bg-pink-50 transition-colors">
                            <input type="radio" name="quiz-example" className="w-4 h-4 text-pink-500" />
                            <span className="text-sm text-slate-700">Der Umfang des Kreises</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 6. Nächste Themen */}
              <div className="bg-gradient-to-r from-cyan-50 to-sky-50 rounded-2xl p-6 border-2 border-cyan-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-sky-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-right-circle-line text-white text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-slate-900 mb-4">6. Was du jetzt als Nächstes lernen könntest</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="bg-white rounded-lg p-4 border border-cyan-200 hover:border-cyan-400 transition-colors cursor-pointer">
                        <div className="flex items-center gap-3">
                          <i className="ri-arrow-right-s-line text-cyan-600 text-xl"></i>
                          <div>
                            <p className="font-semibold text-slate-900 text-sm">Kreisumfang berechnen</p>
                            <p className="text-xs text-slate-600">U = 2 × π × r</p>
                          </div>
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-4 border border-cyan-200 hover:border-cyan-400 transition-colors cursor-pointer">
                        <div className="flex items-center gap-3">
                          <i className="ri-arrow-right-s-line text-cyan-600 text-xl"></i>
                          <div>
                            <p className="font-semibold text-slate-900 text-sm">Volumen einer Kugel</p>
                            <p className="text-xs text-slate-600">V = 4/3 × π × r³</p>
                          </div>
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-4 border border-cyan-200 hover:border-cyan-400 transition-colors cursor-pointer">
                        <div className="flex items-center gap-3">
                          <i className="ri-arrow-right-s-line text-cyan-600 text-xl"></i>
                          <div>
                            <p className="font-semibold text-slate-900 text-sm">Kreisausschnitt</p>
                            <p className="text-xs text-slate-600">Fläche von Kreissegmenten</p>
                          </div>
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-4 border border-cyan-200 hover:border-cyan-400 transition-colors cursor-pointer">
                        <div className="flex items-center gap-3">
                          <i className="ri-arrow-right-s-line text-cyan-600 text-xl"></i>
                          <div>
                            <p className="font-semibold text-slate-900 text-sm">Zylinder berechnen</p>
                            <p className="text-xs text-slate-600">Volumen und Oberfläche</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-8 text-center">
              <Link
                to="/ask-teacher"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-question-answer-line text-2xl"></i>
                <span>Jetzt eigene Frage stellen</span>
              </Link>
              <p className="text-sm text-slate-500 mt-4">
                Kostenlos • Sofortige Antwort • Alle Fächer
              </p>
            </div>
          </div>

          {/* Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-blue-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Alle Fächer</h4>
              <p className="text-sm text-slate-600">Stelle Fragen zu Mathe, Deutsch, Englisch, Biologie und mehr</p>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-indigo-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-save-line text-indigo-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Automatisch gespeichert</h4>
              <p className="text-sm text-slate-600">Alle Fragen und Antworten werden für dich gespeichert</p>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-violet-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-violet-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">24/7 verfügbar</h4>
              <p className="text-sm text-slate-600">Stelle deine Fragen wann immer du willst - Tag und Nacht</p>
            </div>
          </div>
        </div>
      </section>

      {/* NEW: Telegram Bot Section */}
      <section className="py-24 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4 animate-pulse">
              <i className="ri-telegram-line"></i>
              <span>NEU: Telegram Bot</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Lernen per Telegram - Überall & Jederzeit
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Nutze Learnsnap direkt in Telegram! Stelle Fragen im Bus, in der Pause oder zu Hause - wann und wo du willst
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
            {/* Image */}
            <div className="order-2 lg:order-1">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-green-100">
                <img 
                  src="https://readdy.ai/api/search-image?query=teenage%20boy%20student%20age%20fourteen%20sitting%20in%20school%20bus%20holding%20smartphone%20using%20telegram%20messenger%20app%20happy%20smiling%20expression%20brown%20hair%20light%20skin%20tone%20bright%20natural%20daylight%20through%20bus%20window%20modern%20mobile%20learning%20on%20the%20go%20educational%20technology&width=800&height=600&seq=telegram-mobile-learning&orientation=landscape"
                  alt="Schüler nutzt Telegram Bot im Bus"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Content */}
            <div className="order-1 lg:order-2">
              <div className="bg-white rounded-3xl p-8 md:p-10 border-2 border-green-200 shadow-xl">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-telegram-line text-white text-3xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-2">Flexibel von überall lernen</h3>
                    <p className="text-slate-600">Kein Login nötig - einfach Telegram öffnen und loslegen!</p>
                  </div>
                </div>

                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-bus-line text-green-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Im Bus zur Schule</p>
                      <p className="text-sm text-slate-600">Nutze die Fahrtzeit sinnvoll und lerne unterwegs</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-time-line text-green-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">In der Pause</p>
                      <p className="text-sm text-slate-600">Schnell eine Frage klären zwischen zwei Stunden</p>
                      <p className="text-xs text-slate-500 italic mt-1">Falls es in der Pause erlaubt ist</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-home-line text-green-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Zu Hause am Schreibtisch</p>
                      <p className="text-sm text-slate-600">Konzentriert lernen mit deinem Lieblingsmessenger</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-smartphone-line text-green-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Kein Extra-Login</p>
                      <p className="text-sm text-slate-600">Nutze einfach dein bestehendes Telegram-Konto</p>
                    </div>
                  </div>
                </div>

                <a
                  href="https://t.me/LearnSnapBot"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer w-full justify-center"
                >
                  <i className="ri-telegram-line text-2xl"></i>
                  <span>Telegram Bot starten</span>
                </a>
              </div>
            </div>
          </div>

          {/* How it works */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-green-200">
            <h3 className="text-3xl font-bold text-slate-900 mb-8 text-center">So funktioniert's</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-telegram-line text-green-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">1. Bot öffnen</h4>
                <p className="text-sm text-slate-600">Klicke auf den Link oder suche @LearnSnapBot</p>
              </div>

              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-play-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">2. /start senden</h4>
                <p className="text-sm text-slate-600">Starte den Bot mit dem /start Befehl</p>
              </div>

              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-question-line text-emerald-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">3. Frage stellen</h4>
                <p className="text-sm text-slate-600">Schreibe deine Frage einfach als Nachricht</p>
              </div>

              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-violet-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-slate-900 mb-2">4. Antwort erhalten</h4>
                <p className="text-sm text-slate-600">Erhalte sofort eine KI-Erklärung</p>
              </div>
            </div>

            {/* Example Conversation */}
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-6 border-2 border-green-200">
              <h4 className="font-bold text-slate-900 mb-4 text-center">💬 Beispiel-Konversation</h4>
              
              <div className="space-y-4 max-w-2xl mx-auto">
                {/* User Message */}
                <div className="flex justify-end">
                  <div className="bg-green-500 text-white rounded-2xl rounded-tr-sm px-4 py-3 max-w-xs">
                    <p className="text-sm">Was ist die Photosynthese?</p>
                  </div>
                </div>

                {/* Bot Response */}
                <div className="flex justify-start">
                  <div className="bg-white rounded-2xl rounded-tl-sm px-4 py-3 max-w-md border border-green-200">
                    <div className="flex items-center gap-2 mb-2">
                      <i className="ri-robot-line text-green-600"></i>
                      <span className="font-bold text-sm text-slate-900">LearnSnap Bot</span>
                    </div>
                    <p className="text-sm text-slate-700 mb-2">
                      📚 <strong>Erklärung:</strong> Photosynthese ist der Prozess, bei dem Pflanzen Lichtenergie in chemische Energie umwandeln...
                    </p>
                    <p className="text-xs text-slate-500">✅ Gespeichert in deinem Lernfortschritt</p>
                  </div>
                </div>

                {/* Stats Command */}
                <div className="flex justify-end">
                  <div className="bg-green-500 text-white rounded-2xl rounded-tr-sm px-4 py-3 max-w-xs">
                    <p className="text-sm">/stats</p>
                  </div>
                </div>

                {/* Stats Response */}
                <div className="flex justify-start">
                  <div className="bg-white rounded-2xl rounded-tl-sm px-4 py-3 max-w-md border border-green-200">
                    <div className="flex items-center gap-2 mb-2">
                      <i className="ri-robot-line text-green-600"></i>
                      <span className="font-bold text-sm text-slate-900">LearnSnap Bot</span>
                    </div>
                    <p className="text-sm text-slate-700">
                      📊 <strong>Dein Lernfortschritt:</strong><br/>
                      • 1 Frage gestellt<br/>
                      • 1 Badge verdient 🎯<br/>
                      • Top Fach: Biologie
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-green-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Datenschutz</h4>
              <p className="text-sm text-slate-600">Deine Daten bleiben sicher - DSGVO-konform</p>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-save-line text-blue-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Automatisch gespeichert</h4>
              <p className="text-sm text-slate-600">Alle Fragen werden in deinem Profil gespeichert</p>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-violet-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-violet-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Badges sammeln</h4>
              <p className="text-sm text-slate-600">Verdiene Badges für deine Lernfortschritte</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Warum Learnsnap?</h2>
            <p className="text-base text-slate-600 max-w-2xl mx-auto">
              Die perfekte Kombination aus künstlicher Intelligenz und bewährten Lernmethoden - Learnsnap erklärt dir Lösungswege so, dass du sie wirklich verstehst
            </p>
          </div>

          {/* Features Grid with Student Image */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            {features.slice(0, 6).map((feature, index) => (
              <div key={index} className="bg-slate-50 rounded-2xl p-8 hover:shadow-xl transition-all border border-slate-100">
                <div className={`w-14 h-14 ${feature.color} rounded-xl flex items-center justify-center mb-6`}>
                  <i className={`${feature.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3">{feature.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Student Learning Image Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="order-2 lg:order-1">
              <div className="bg-slate-50 rounded-2xl p-8 hover:shadow-xl transition-all border border-slate-100">
                <div className={`w-14 h-14 ${features[6].color} rounded-xl flex items-center justify-center mb-6`}>
                  <i className={`${features[6].icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3">{features[6].title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{features[6].description}</p>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white/20">
                <img 
                  src="https://readdy.ai/api/search-image?query=teenage%20girl%20student%20age%20twelve%20taking%20photo%20of%20textbook%20page%20with%20smartphone%20happy%20excited%20expression%20blonde%20hair%20light%20skin%20tone%20bright%20study%20room%20natural%20daylight%20books%20and%20study%20materials%20visible%20modern%20digital%20learning%20technology&width=800&height=600&seq=student-uploading-material&orientation=landscape"
                  alt="Schülerin beim Hochladen von Lernmaterial"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* KI-Personalisierung Section */}
      <section className="py-24 bg-gradient-to-br from-violet-50 via-purple-50 to-fuchsia-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-violet-100 text-violet-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-brain-line"></i>
              Künstliche Intelligenz
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Intelligente Personalisierung
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Learnsnap lernt kontinuierlich von deinem Lernverhalten und passt sich automatisch an deine individuellen Bedürfnisse an
            </p>
          </div>

          {/* Main Feature Card with Student Image */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-violet-200 mb-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-violet-100">
                  <img 
                    src="https://readdy.ai/api/search-image?query=teenage%20boy%20student%20age%20sixteen%20using%20laptop%20for%20online%20learning%20sitting%20at%20modern%20desk%20happy%20smiling%20expression%20brown%20hair%20light%20skin%20tone%20bright%20study%20room%20with%20window%20natural%20daylight%20educational%20technology%20digital%20learning%20environment&width=800&height=600&seq=student-ai-learning&orientation=landscape"
                    alt="Schüler beim Learnsnap-gestützten Lernen"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div>
                <div className="w-20 h-20 bg-gradient-to-br from-violet-500 to-fuchsia-500 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-sparkling-2-line text-white text-4xl"></i>
                </div>
                <h3 className="text-3xl font-bold text-slate-900 mb-4">
                  Learnsnap versteht dich wirklich
                </h3>
                <p className="text-lg text-slate-600 leading-relaxed mb-6">
                  Learnsnap analysiert kontinuierlich deine Antworten, Fehler und Lernmuster. Je mehr du lernst, desto besser versteht Learnsnap deine individuellen Stärken und Schwächen.
                </p>
              </div>
            </div>
          </div>

          {/* How It Works */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 border border-slate-200 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-rose-500 to-pink-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-focus-3-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Stärken & Schwächen</h4>
              <p className="text-slate-600 leading-relaxed">
                Learnsnap erstellt ein detailliertes Profil deiner Fähigkeiten und zeigt dir genau, wo du stehst und was du noch üben solltest
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-slate-200 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-route-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Adaptiver Lernpfad</h4>
              <p className="text-slate-600 leading-relaxed">
                Basierend auf deinen Ergebnissen passt Learnsnap den Schwierigkeitsgrad und die Themenauswahl dynamisch an
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-slate-200 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-magic-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Smarte Empfehlungen</h4>
              <p className="text-slate-600 leading-relaxed">
                Erhalte personalisierte Vorschläge für dein nächstes Lernmodul - immer perfekt auf dein aktuelles Niveau abgestimmt
              </p>
            </div>
          </div>

          {/* Stats Banner */}
          <div className="mt-12 bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 rounded-2xl p-8 text-white">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-4xl font-bold mb-2">87%</div>
                <p className="text-white/90">Genauere Schwachstellen-Erkennung als traditionelle Methoden</p>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">3x</div>
                <p className="text-white/90">Schnellere Verbesserung durch personalisierte Lernpfade</p>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">24/7</div>
                <p className="text-white/90">Kontinuierliche Anpassung an dein Lernverhalten</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NEW: KI vs. Lehrer Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-lightbulb-line"></i>
              Warum Learnsnap-Erklärungen?
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Wie Learnsnap Lösungswege besser erklärt
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Learnsnap ergänzt traditionelle Nachhilfe perfekt - mit einzigartigen Vorteilen, die nur künstliche Intelligenz bieten kann
            </p>
          </div>

          {/* Comparison Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* KI Advantages */}
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-8 border-2 border-teal-200">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center">
                  <i className="ri-robot-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900">Learnsnap-Nachhilfe</h3>
                  <p className="text-sm text-slate-600">Dein persönlicher Lernassistent</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-xl p-5 border border-teal-200">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">100% auf dich zugeschnitten</h4>
                      <p className="text-sm text-slate-600">Learnsnap passt Erklärungen exakt an dein Niveau, deine Fehler und deinen Lernstil an - jede Erklärung ist individuell für dich</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-teal-200">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Unbegrenzte Geduld</h4>
                      <p className="text-sm text-slate-600">Frag so oft du willst - Learnsnap erklärt dir denselben Lösungsweg auf 10 verschiedene Arten, bis du es verstehst. Ohne Zeitdruck oder Ungeduld</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-teal-200">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-eye-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Visuelle Lernwege</h4>
                      <p className="text-sm text-slate-600">Schritt-für-Schritt mit Farben, Diagrammen und Visualisierungen - Learnsnap zeigt dir den Lösungsweg so, wie du am besten lernst</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-teal-200">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-refresh-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Intelligente Wiederholung</h4>
                      <p className="text-sm text-slate-600">Learnsnap merkt sich genau, was du noch üben musst und wiederholt schwierige Themen automatisch zum optimalen Zeitpunkt</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-teal-200">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-money-euro-circle-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Für jeden bezahlbar</h4>
                      <p className="text-sm text-slate-600">Hochwertige Erklärungen zu einem Bruchteil der Kosten traditioneller Nachhilfe - ohne Qualitätsverlust</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Traditional Tutoring */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-3xl p-8 border-2 border-slate-200">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-slate-500 to-gray-600 rounded-2xl flex items-center justify-center">
                  <i className="ri-user-3-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900">Traditionelle Nachhilfe</h3>
                  <p className="text-sm text-slate-600">Klassischer Nachhilfelehrer</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-xl p-5 border border-slate-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-slate-400 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-group-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Standardisierte Erklärungen</h4>
                      <p className="text-sm text-slate-600">Lehrer verwenden oft dieselben Erklärungen für alle Schüler - nicht immer optimal für deinen individuellen Lernstil</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-slate-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-slate-400 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-timer-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Begrenzte Zeit</h4>
                      <p className="text-sm text-slate-600">Nachhilfestunden sind zeitlich begrenzt - manchmal reicht die Zeit nicht, um alles in Ruhe zu erklären</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-slate-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-slate-400 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-calendar-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Manuelle Nachverfolgung</h4>
                      <p className="text-sm text-slate-600">Lehrer müssen sich manuell merken, was du noch üben musst - nicht immer perfekt organisiert</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-slate-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-slate-400 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-book-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Klassische Methoden</h4>
                      <p className="text-sm text-slate-600">Meist Tafel und Papier - moderne visuelle und interaktive Lernmethoden werden seltener eingesetzt</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-slate-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-slate-400 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-file-list-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Manuelle Nachverfolgung</h4>
                      <p className="text-sm text-slate-600">Lehrer müssen sich manuell merken, was du noch üben musst - nicht immer perfekt organisiert</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-slate-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-slate-400 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-money-euro-box-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">Hohe Kosten</h4>
                      <p className="text-sm text-slate-600">20-40€ pro Stunde - für viele Familien auf Dauer nicht bezahlbar</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Key Insight Box */}
          <div className="bg-gradient-to-r from-teal-500 via-emerald-500 to-green-500 rounded-3xl p-8 md:p-12 text-white text-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-heart-line text-3xl"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">Das Beste aus beiden Welten</h3>
            <p className="text-xl text-white/90 max-w-3xl mx-auto mb-6">
              Learnsnap ersetzt keine Lehrer - es ergänzt sie perfekt! Während Lehrer Motivation, Struktur und menschliche Interaktion bieten, liefert Learnsnap personalisierte, geduldige und jederzeit verfügbare Erklärungen.
            </p>
            <div className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm rounded-full px-6 py-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="font-semibold">Learnsnap = Schulunterricht + Learnsnap-Power</span>
            </div>
          </div>

          {/* Real Example with Student Image */}
          <div className="mt-12 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-3xl p-8 md:p-12 border-2 border-indigo-200">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-8">
              <div className="order-2 lg:order-1">
                <div className="text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    <i className="ri-chat-quote-line"></i>
                    Praxis-Beispiel
                  </div>
                  <h3 className="text-3xl font-bold text-slate-900 mb-2">So erklärt Learnsnap</h3>
                  <p className="text-slate-600">Ein konkretes Beispiel aus dem Mathe-Unterricht</p>
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-indigo-100">
                  <img 
                    src="https://readdy.ai/api/search-image?query=teenage%20girl%20student%20age%20fifteen%20working%20on%20math%20homework%20at%20desk%20with%20notebook%20and%20calculator%20focused%20thinking%20expression%20brown%20hair%20light%20skin%20tone%20bright%20study%20space%20natural%20daylight%20books%20and%20study%20materials%20visible%20educational%20learning%20environment&width=800&height=600&seq=student-math-learning&orientation=landscape"
                    alt="Schülerin beim Mathe-Lernen"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-indigo-200">
              <div className="mb-6">
                <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-semibold mb-3">
                  <i className="ri-question-line"></i>
                  Aufgabe
                </div>
                <p className="text-lg font-semibold text-slate-900">Was ist die Ableitung von f(x) = x²?</p>
              </div>

              <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl p-6 border border-teal-200">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-robot-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Learnsnap-Erklärung (personalisiert für dich):</h4>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-4 border border-teal-200">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-teal-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">1</div>
                      <div>
                        <p className="text-sm text-slate-700"><strong>Erinnerst du dich an die Potenzregel?</strong> Die hast du letzte Woche gelernt: Wenn f(x) = x<sup>n</sup>, dann ist f'(x) = n · x<sup>n-1</sup></p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 border border-teal-200">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-teal-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">2</div>
                      <div>
                        <p className="text-sm text-slate-700"><strong>Bei x² ist n = 2.</strong> Das setzen wir in die Formel ein: f'(x) = 2 · x<sup>2-1</sup> = 2 · x<sup>1</sup> = 2x</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 border border-teal-200">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-teal-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">3</div>
                      <div>
                        <p className="text-sm text-slate-700"><strong>Visuell:</strong> Stell dir vor, x² ist eine Kurve. Die Ableitung 2x sagt dir, wie steil die Kurve an jedem Punkt ist!</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-indigo-50 rounded-lg p-4 border border-indigo-200">
                    <div className="flex items-start gap-2">
                      <i className="ri-star-line text-indigo-600 text-lg flex-shrink-0"></i>
                      <div>
                        <p className="text-sm text-indigo-900"><strong>Lerntipp für dich:</strong> Du hattest bei der letzten Aufgabe Schwierigkeiten mit Exponenten. Übe noch 3 ähnliche Aufgaben, dann sitzt das!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lernmodi Section */}
      <section className="py-24 bg-gradient-to-br from-slate-50 via-white to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Zwei Lernmodi für jeden Bedarf</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Wähle den passenden Modus für deine Lernsituation - flexibel und individuell
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {/* Testvorbereitung Mode */}
            <div className="bg-white rounded-3xl p-8 border-2 border-teal-200 hover:border-teal-400 hover:shadow-2xl transition-all relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-teal-500/10 to-emerald-500/10 rounded-bl-full"></div>
              <div className="relative">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-calendar-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Testvorbereitung</h3>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  Perfekt für die gezielte Vorbereitung auf Schulaufgaben, Klausuren und Tests. Learnsnap erstellt einen optimalen Testplan basierend auf deinem Zeitrahmen.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Testdatum eingeben</p>
                      <p className="text-sm text-slate-600">Gib an, wann dein Test stattfindet</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Themen auswählen</p>
                      <p className="text-sm text-slate-600">Wähle die relevanten Kapitel und Themen</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Personalisierter Testplan</p>
                      <p className="text-sm text-slate-600">Erhalte einen maßgeschneiderten Zeitplan mit täglichen Lernzielen</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Gezielte Übungen</p>
                      <p className="text-sm text-slate-600">Trainiere mit Fragen aus deiner Wissensdatenbank</p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl p-4 border border-teal-200">
                  <div className="flex items-center gap-2 text-teal-700">
                    <i className="ri-lightbulb-line text-lg"></i>
                    <span className="text-sm font-medium">Ideal für: Schulaufgaben, Klausuren, Abschlussprüfungen</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Thema lernen Mode */}
            <div className="bg-white rounded-3xl p-8 border-2 border-orange-200 hover:border-orange-400 hover:shadow-2xl transition-all relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-500/10 to-amber-500/10 rounded-bl-full"></div>
              <div className="relative">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-500 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-book-open-line text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Thema lernen</h3>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  Lerne in deinem eigenen Tempo. Wähle ein Kapitel oder Thema aus und vertiefe dein Wissen ohne Zeitdruck - perfekt für kontinuierliches Lernen.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-orange-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Fach wählen</p>
                      <p className="text-sm text-slate-600">Wähle aus deinen Schulfächern</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-orange-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Kapitel auswählen</p>
                      <p className="text-sm text-slate-600">Entscheide selbst, was du lernen möchtest</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-orange-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Flexibles Lerntempo</p>
                      <p className="text-sm text-slate-600">Kein Zeitdruck - lerne wann und wie lange du möchtest</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-orange-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Interaktive Übungen</p>
                      <p className="text-sm text-slate-600">Festige dein Wissen mit passenden Aufgaben</p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl p-4 border border-orange-200">
                  <div className="flex items-center gap-2 text-orange-700">
                    <i className="ri-time-line text-lg"></i>
                    <span className="text-sm font-medium">Ideal für: Kontinuierliches Lernen, Wissenserweiterung, Nachbereitung</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comparison Note */}
          <div className="mt-12 text-center">
            <div className="inline-flex items-center gap-3 bg-white rounded-full px-6 py-3 border border-slate-200 shadow-sm">
              <i className="ri-information-line text-slate-600 text-lg"></i>
              <p className="text-sm text-slate-600">
                <strong className="text-slate-900">Tipp:</strong> Du kannst jederzeit zwischen beiden Modi wechseln
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Reflexion & Verbesserung Section */}
      <section className="py-20 bg-gradient-to-br from-slate-50 via-white to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-refresh-line"></i>
              Kontinuierliche Verbesserung
            </div>
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Reflexion nach Tests & Schulaufgaben
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Lerne aus jedem Test und werde kontinuierlich besser. Zwei Wege zur Verbesserung stehen dir zur Verfügung.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Option 1: Selbstbewertung */}
            <div className="bg-white rounded-2xl border-2 border-slate-200 p-8 hover:border-indigo-300 hover:shadow-xl transition-all">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 bg-gradient-to-br from-indigo-500 to-violet-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-edit-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">Selbstbewertung</h3>
                  <p className="text-slate-600">Reflektiere deine Leistung selbst und identifiziere Verbesserungspotenziale</p>
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-1 text-indigo-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Bewerte deine Leistung</p>
                    <p className="text-sm text-slate-600">Gib eine Selbsteinschätzung von 1-10</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-2 text-indigo-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Identifiziere Stärken</p>
                    <p className="text-sm text-slate-600">Was lief besonders gut?</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-3 text-indigo-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Erkenne Schwächen</p>
                    <p className="text-sm text-slate-600">Wo gibt es noch Verbesserungsbedarf?</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-4 text-indigo-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Setze Ziele</p>
                    <p className="text-sm text-slate-600">Was möchtest du beim nächsten Mal verbessern?</p>
                  </div>
                </div>
              </div>

              <div className="bg-indigo-50 rounded-xl p-4 border border-indigo-200">
                <div className="flex items-start gap-3">
                  <i className="ri-lightbulb-line text-indigo-600 text-xl flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-indigo-900 text-sm mb-1">Perfekt für:</p>
                    <p className="text-sm text-indigo-700">Schnelle Reflexion direkt nach dem Test, Entwicklung von Selbstwahrnehmung</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Option 2: Testergebnisse hochladen */}
            <div className="bg-white rounded-2xl border-2 border-slate-200 p-8 hover:border-teal-300 hover:shadow-xl transition-all">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-upload-cloud-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">Testergebnisse hochladen</h3>
                  <p className="text-slate-600">Lade deine korrigierte Schulaufgabe hoch für präzise KI-Analyse</p>
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-1 text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Screenshot hochladen</p>
                    <p className="text-sm text-slate-600">Fotografiere deine korrigierte Schulaufgabe</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-2 text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">KI-Auswertung</p>
                    <p className="text-sm text-slate-600">Automatische Analyse deiner Fehler und Schwachstellen</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-3 text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Gezielte Übungen</p>
                    <p className="text-sm text-slate-600">Schwachstellen werden in zukünftige Lernpläne integriert</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-number-4 text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Kontinuierliche Verbesserung</p>
                    <p className="text-sm text-slate-600">Fokussiertes Training deiner Problemthemen</p>
                  </div>
                </div>
              </div>

              <div className="bg-teal-50 rounded-xl p-4 border border-teal-200">
                <div className="flex items-start gap-3">
                  <i className="ri-lightbulb-line text-teal-600 text-xl flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-teal-900 text-sm mb-1">Perfekt für:</p>
                    <p className="text-sm text-teal-700">Präzise Fehleranalyse, datenbasierte Verbesserung, langfristige Lernoptimierung</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefit Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-purple-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Messbare Fortschritte</h4>
              <p className="text-sm text-slate-600">Verfolge deine Verbesserung von Test zu Test mit detaillierten Statistiken</p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-rose-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-focus-line text-rose-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Fokussiertes Lernen</h4>
              <p className="text-sm text-slate-600">Konzentriere dich auf deine tatsächlichen Schwachstellen statt alles zu wiederholen</p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-amber-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Schnellere Verbesserung</h4>
              <p className="text-sm text-slate-600">Durch gezielte Übungen erreichst du deine Lernziele deutlich schneller</p>
            </div>
          </div>

          {/* Info Banner */}
          <div className="mt-12 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-2xl p-8 text-white text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-heart-line text-3xl"></i>
              <h3 className="text-2xl font-bold">Deine Meinung zählt!</h3>
            </div>
            <p className="text-white/90 text-lg max-w-3xl mx-auto">
              Jedes Feedback hilft uns, Learnsnap besser zu machen. Gemeinsam schaffen wir die beste Lern-App für Schüler!
            </p>
          </div>
        </div>
      </section>

      {/* NEW: Feedback & Erinnerungen Section */}
      <section className="py-24 bg-gradient-to-br from-indigo-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-star-line"></i>
              Kontinuierliche Verbesserung
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Dein Feedback macht uns besser
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Wir hören auf dich und verbessern Learnsnap kontinuierlich basierend auf deinem Feedback
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Feedback System */}
            <div className="bg-white rounded-3xl p-8 md:p-10 border-2 border-violet-200 hover:shadow-2xl transition-all">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-violet-500 to-purple-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-thumb-up-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">Feedback-System</h3>
                  <p className="text-slate-600">Bewerte jede KI-Erklärung und hilf uns besser zu werden</p>
                </div>
              </div>

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-violet-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-violet-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Einfache Bewertung</p>
                    <p className="text-sm text-slate-600">Daumen hoch oder runter bei jeder Erklärung</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-violet-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-violet-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Direkte Auswirkung</p>
                    <p className="text-sm text-slate-600">Dein Feedback verbessert die KI sofort für alle</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-violet-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-violet-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Qualitätssicherung</p>
                    <p className="text-sm text-slate-600">Wir prüfen jedes negative Feedback manuell</p>
                  </div>
                </div>
              </div>

              {/* Visual Example */}
              <div className="bg-gradient-to-r from-violet-50 to-purple-50 rounded-2xl p-6 border border-violet-200">
                <p className="text-sm text-slate-700 mb-4 font-medium">So sieht das Feedback aus</p>
                <div className="bg-white rounded-xl p-4 border border-violet-200">
                  <p className="text-sm text-slate-600 mb-3">War diese Erklärung hilfreich?</p>
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2 px-4 py-2 bg-green-100 text-green-700 rounded-lg text-sm font-medium">
                      <i className="ri-thumb-up-line text-lg"></i>
                      <span>Hilfreich</span>
                    </div>
                    <div className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium">
                      <i className="ri-thumb-down-line text-lg"></i>
                      <span>Nicht hilfreich</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Erinnerungen */}
            <div className="bg-white rounded-3xl p-8 md:p-10 border-2 border-indigo-200 hover:shadow-2xl transition-all">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-notification-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">Browser-Erinnerungen</h3>
                  <p className="text-slate-600">Verpasse nie wieder eine wichtige Lernsession</p>
                </div>
              </div>

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-indigo-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Test-Erinnerungen</p>
                    <p className="text-sm text-slate-600">Werde rechtzeitig an anstehende Tests erinnert</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-indigo-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Lernstreak-Warnung</p>
                    <p className="text-sm text-slate-600">Behalte deinen Lernstreak mit täglichen Erinnerungen</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-indigo-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Wiederholungs-Hinweise</p>
                    <p className="text-sm text-slate-600">Automatische Erinnerungen für Spaced Repetition</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-indigo-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Individuelle Zeiten</p>
                    <p className="text-sm text-slate-600">Stelle deine bevorzugten Lernzeiten ein</p>
                  </div>
                </div>
              </div>

              {/* Visual Example */}
              <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-2xl p-6 border border-indigo-200">
                <p className="text-sm text-slate-700 mb-4 font-medium">Beispiel-Benachrichtigung:</p>
                <div className="bg-white rounded-xl p-4 border border-indigo-200 shadow-lg">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-graduation-cap-fill text-white text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <p className="font-bold text-slate-900 text-sm mb-1">Learnsnap</p>
                      <p className="text-sm text-slate-700">🔥 Dein Lernstreak läuft heute ab! Lerne jetzt 10 Minuten, um ihn zu behalten.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-violet-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-violet-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Bessere KI-Erklärungen</h4>
              <p className="text-sm text-slate-600">Durch dein Feedback werden die Erklärungen immer verständlicher</p>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-indigo-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-indigo-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Nie wieder vergessen</h4>
              <p className="text-sm text-slate-600">Erinnerungen helfen dir, konsequent zu lernen und deine Ziele zu erreichen</p>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
              <div className="w-14 h-14 bg-pink-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-community-line text-pink-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-slate-900 mb-2">Community-getrieben</h4>
              <p className="text-sm text-slate-600">Jeder Schüler profitiert von den Verbesserungen durch die Community</p>
            </div>
          </div>

          {/* Info Banner */}
          <div className="mt-12 bg-gradient-to-r from-violet-500 via-purple-500 to-indigo-500 rounded-2xl p-8 text-white text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-heart-line text-3xl"></i>
              <h3 className="text-2xl font-bold">Deine Meinung zählt!</h3>
            </div>
            <p className="text-white/90 text-lg max-w-3xl mx-auto">
              Jedes Feedback hilft uns, Learnsnap besser zu machen. Gemeinsam schaffen wir die beste Lern-App für Schüler!
            </p>
          </div>
        </div>
      </section>

      {/* Subjects Section */}
      <section id="subjects" className="py-24 bg-gradient-to-br from-slate-50 via-white to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Alle wichtigen Schulfächer</h2>
            <p className="text-base text-slate-600 max-w-2xl mx-auto">
              Von Mathematik bis Sprachen - Learnsnap unterstützt dich in allen Hauptfächern
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="order-2 lg:order-1">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                {subjects.map((subject, index) => (
                  <div key={index} className="bg-white rounded-2xl p-6 hover:shadow-xl transition-all border border-slate-100 text-center">
                    <div className={`w-16 h-16 bg-gradient-to-br ${subject.color} rounded-xl flex items-center justify-center mx-auto mb-4`}>
                      <i className={`${subject.icon} text-white text-3xl`}></i>
                    </div>
                    <h3 className="font-bold text-slate-900">{subject.name}</h3>
                  </div>
                ))}
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white/20">
                <img 
                  src="https://readdy.ai/api/search-image?query=teenage%20boy%20student%20age%20thirteen%20studying%20with%20textbooks%20and%20laptop%20at%20desk%20happy%20smiling%20expression%20blonde%20hair%20light%20skin%20tone%20bright%20modern%20study%20room%20natural%20daylight%20through%20window%20multiple%20school%20books%20visible%20motivated%20learning%20atmosphere&width=800&height=600&seq=student-multiple-subjects&orientation=landscape"
                  alt="Schüler beim Lernen verschiedener Fächer"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section id="how-it-works" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">So einfach geht's</h2>
            <p className="text-base text-slate-600 max-w-2xl mx-auto">
              In nur 4 Schritten zu besseren Noten
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="order-2 lg:order-1">
              <div className="space-y-8">
                {steps.map((step, index) => (
                  <div key={index} className="flex items-start gap-6 bg-slate-50 rounded-2xl p-6 hover:shadow-lg transition-all border border-slate-100">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center">
                        <i className={`${step.icon} text-white text-2xl`}></i>
                      </div>
                    </div>
                    <div>
                      <div className="text-sm font-bold text-teal-600 mb-2">{step.number}</div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2">{step.title}</h3>
                      <p className="text-sm text-slate-600">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
                <img 
                  src="https://readdy.ai/api/search-image?query=teenage%20girl%20student%20age%20twelve%20taking%20photo%20of%20textbook%20page%20with%20smartphone%20happy%20excited%20expression%20blonde%20hair%20light%20skin%20tone%20bright%20study%20room%20natural%20daylight%20books%20and%20study%20materials%20visible%20modern%20digital%20learning%20technology&width=800&height=600&seq=student-uploading-material&orientation=landscape"
                  alt="Schülerin beim Hochladen von Lernmaterial"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-24 bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Das sagen unsere Schüler
            </h2>
            <p className="text-base text-slate-600 max-w-2xl mx-auto">
              Echte Erfahrungen von Schülern, die mit Learnsnap ihre Noten verbessert haben
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-xl border border-slate-100 hover:shadow-2xl transition-all">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 rounded-full overflow-hidden border-4 border-teal-100">
                    <img 
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900">{testimonial.name}</h4>
                    <p className="text-sm text-slate-600">{testimonial.grade}</p>
                  </div>
                </div>
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-slate-700 leading-relaxed italic">"{testimonial.text}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-24 bg-gradient-to-r from-teal-600 via-emerald-600 to-green-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="grid grid-cols-2 gap-8">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-5xl font-bold text-white mb-2">{stat.number}</div>
                    <p className="text-white/90 font-medium">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white/20">
                <img 
                  src="https://readdy.ai/api/search-image?query=group%20of%20four%20diverse%20teenage%20students%20celebrating%20success%20together%20high%20five%20gesture%20happy%20excited%20expressions%20ages%20twelve%20to%20sixteen%20years%20old%20blonde%20brown%20hair%20light%20skin%20tones%20bright%20modern%20study%20space%20natural%20daylight%20achievement%20celebration%20learning%20success&width=800&height=600&seq=students-celebrating-success&orientation=landscape"
                  alt="Schüler feiern gemeinsam ihren Lernerfolg"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership / White-Label Teaser */}
      <PartnershipTeaser />

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-teal-500 to-emerald-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Bereit, dein Lernen zu revolutionieren?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Lade jetzt deinen ersten Screenshot hoch und erlebe, wie KI dein Lernen auf das nächste Level bringt
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/auth/register"
              className="px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-xl font-semibold hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-upload-cloud-2-line mr-2"></i>
              Jetzt kostenlos starten
            </Link>
            <Link
              to="/upload-knowledge"
              className="px-8 py-4 bg-white text-teal-600 rounded-xl font-semibold hover:shadow-xl transition-all border-2 border-teal-500 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-upload-cloud-2-line mr-2"></i>
              Kostenlos testen (ohne Anmeldung)
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <Logo size="sm" showText={true} textColor="text-white" className="mb-4" />
              <p className="text-sm text-slate-400 leading-relaxed">
                KI-gestützte Nachhilfe für jeden - bezahlbar und rund um die Uhr verfügbar.
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold text-base mb-4">Produkt</h4>
              <ul className="space-y-3">
                <li><a href="#features" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">Funktionen</a></li>
                <li><a href="#subjects" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">Fächer</a></li>
                <li><a href="#how-it-works" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">So funktioniert's</a></li>
                <li><a href="#career" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">Karriere</a></li>
                <li><Link to="/partnerschaft" className="text-sm text-teal-400 hover:text-teal-300 transition-colors cursor-pointer font-semibold flex items-center gap-1"><i className="ri-handshake-line"></i>Kooperation &amp; White-Label</Link></li>
                <li><Link to="/dashboard" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">Schüler Login</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold text-base mb-4">Rechtliches</h4>
              <ul className="space-y-3">
                <li><Link to="/datenschutz" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">Datenschutz</Link></li>
                <li><Link to="/agb" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">AGB</Link></li>
                <li><Link to="/impressum" className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer">Impressum</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-base mb-4">Kontakt</h4>
              <div className="space-y-3 text-sm text-slate-400">
                <p className="font-medium text-white">Future Now UG</p>
                <p>Max-Planck-Str. 4<br />85609 Aschheim</p>
                <p>
                  <a href="mailto:info@future-now.online" className="text-teal-400 hover:text-teal-300 transition-colors">
                    info@future-now.online
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Career Partnership Section */}
          <div id="career" className="border-t border-slate-800 pt-12 mb-12">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-8">
                <div className="inline-flex items-center gap-2 bg-teal-500/10 text-teal-400 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                  <i className="ri-lightbulb-line"></i>
                  Werde Teil von etwas Einzigartigem
                </div>
                <h3 className="text-3xl font-bold text-white mb-3">Karriere & Partnerschaft</h3>
                <p className="text-base text-slate-400 max-w-2xl mx-auto">
                  Learnsnap revolutioniert die Art, wie Schüler lernen. Werde Teil unserer Mission als Vertriebspartner oder beteilige dich an unserem innovativen Unternehmen.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-slate-800 rounded-2xl p-6 border border-slate-700">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-team-line text-white text-2xl"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Vertriebspartner</h4>
                  <p className="text-sm text-slate-400 leading-relaxed mb-4">
                    Werde Teil unseres Vertriebsteams und helfe uns, Learnsnap an Schulen, Bildungseinrichtungen und Schüler zu bringen.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2 text-sm text-slate-300">
                      <i className="ri-check-line text-teal-400 mt-0.5"></i>
                      <span>Attraktive Provisionsmodelle</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-slate-300">
                      <i className="ri-check-line text-teal-400 mt-0.5"></i>
                      <span>Flexible Arbeitszeiten</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-slate-300">
                      <i className="ri-check-line text-teal-400 mt-0.5"></i>
                      <span>Umfassende Schulungen</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-slate-800 rounded-2xl p-6 border border-slate-700">
                  <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-briefcase-line text-white text-2xl"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Unternehmensbeteiligung</h4>
                  <p className="text-sm text-slate-400 leading-relaxed mb-4">
                    Investiere in die Zukunft der Bildung und werde Teil unseres Erfolgs durch eine strategische Unternehmensbeteiligung.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2 text-sm text-slate-300">
                      <i className="ri-check-line text-indigo-400 mt-0.5"></i>
                      <span>Innovatives Geschäftsmodell</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-slate-300">
                      <i className="ri-check-line text-indigo-400 mt-0.5"></i>
                      <span>Wachstumsstarker Markt</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-slate-300">
                      <i className="ri-check-line text-indigo-400 mt-0.5"></i>
                      <span>Nachhaltige Wertschöpfung</span>
                    </li>
                  </ul>
                </div>
              </div>

              <form 
                id="career-form"
                data-readdy-form
                action="https://readdy.ai/api/form/d5nm12e74ha8pf6snlug" 
                method="POST"
                className="bg-slate-800 rounded-2xl p-8 border border-slate-700"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="career-name" className="block text-sm font-medium text-slate-300 mb-2">
                      Name *
                    </label>
                    <input
                      type="text"
                      id="career-name"
                      name="name"
                      required
                      className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                      placeholder="Dein vollständiger Name"
                    />
                  </div>
                  <div>
                    <label htmlFor="career-email" className="block text-sm font-medium text-slate-300 mb-2">
                      E-Mail *
                    </label>
                    <input
                      type="email"
                      id="career-email"
                      name="email"
                      required
                      className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                      placeholder="deine@email.de"
                    />
                  </div>
                </div>

                <div className="mb-6">
                  <label htmlFor="career-phone" className="block text-sm font-medium text-slate-300 mb-2">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    id="career-phone"
                    name="phone"
                    className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    placeholder="Optional"
                  />
                </div>
                
                <div className="mb-6">
                  <label htmlFor="career-interest" className="block text-sm font-medium text-slate-300 mb-2">
                    Ich interessiere mich für *
                  </label>
                  <select
                    id="career-interest"
                    name="interest"
                    required
                    className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  >
                    <option value="">Bitte wählen...</option>
                    <option value="Vertriebspartner">Vertriebspartner</option>
                    <option value="Unternehmensbeteiligung">Unternehmensbeteiligung</option>
                    <option value="Beides">Beides</option>
                  </select>
                </div>
                
                <div className="mb-6">
                  <label htmlFor="career-message" className="block text-sm font-medium text-slate-300 mb-2">
                    Nachricht *
                  </label>
                  <textarea
                    id="career-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all resize-none"
                    placeholder="Erzähle uns von dir und deinem Interesse (max. 500 Zeichen)"
                  ></textarea>
                  <p className="text-xs text-slate-500 mt-2">Maximal 500 Zeichen</p>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:shadow-lg transition-all whitespace-nowrap"
                >
                  Anfrage senden
                </button>
                
                <div id="career-form-message" className="mt-4 text-center text-sm hidden"></div>
              </form>
            </div>
          </div>

          {/* Contact Form Section */}
          <div id="contact" className="border-t border-slate-800 pt-12 mb-12">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-white mb-2">Kontaktiere uns</h3>
                <p className="text-sm text-slate-400">Hast du Fragen? Wir helfen dir gerne weiter!</p>
              </div>
              
              <form 
                id="contact-form"
                data-readdy-form
                action="https://readdy.ai/api/form/d4o5mc2jh8g73q73a2m0" 
                method="POST"
                className="bg-slate-800 rounded-2xl p-8 border border-slate-700"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-slate-300 mb-2">
                      Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                      placeholder="Dein Name"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2">
                      E-Mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                      placeholder="deine@email.de"
                    />
                  </div>
                </div>
                
                <div className="mb-6">
                  <label htmlFor="subject" className="block text-sm font-medium text-slate-300 mb-2">
                    Betreff *
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    placeholder="Worum geht es?"
                  />
                </div>
                
                <div className="mb-6">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-300 mb-2">
                    Nachricht *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all resize-none"
                    placeholder="Deine Nachricht (max. 500 Zeichen)"
                  ></textarea>
                  <p className="text-xs text-slate-500 mt-2">Maximal 500 Zeichen</p>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:shadow-lg transition-all whitespace-nowrap"
                >
                  Nachricht senden
                </button>
                
                <div id="form-message" className="mt-4 text-center text-sm hidden"></div>
              </form>
            </div>
          </div>
          
          <div className="border-t border-slate-800 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
              <p className="text-slate-400 text-sm">
                © 2024 Learnsnap. Alle Rechte vorbehalten.
              </p>
              <div className="flex items-center gap-4">
                <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-slate-300 text-sm transition-colors cursor-pointer">
                  Powered by Readdy
                </a>
              </div>
            </div>
            
            {/* Dezenter Disclaimer */}
            <div className="text-center">
              <p className="text-xs text-slate-500 leading-relaxed max-w-4xl mx-auto">
                Learnsnap ist eine KI-gestützte Lernplattform zur Unterstützung des selbstständigen Lernens. Wir übernehmen keine Garantie für Lernerfolge, Notenverbesserungen oder die vollständige Richtigkeit aller Inhalte. Die Plattform ersetzt keine professionelle Nachhilfe oder schulische Betreuung. Die Nutzung erfolgt auf eigene Verantwortung. Weitere Informationen finden Sie in unseren <Link to="/agb" className="text-slate-400 hover:text-slate-300 underline">AGB</Link> und der <Link to="/datenschutz" className="text-slate-400 hover:text-slate-300 underline">Datenschutzerklärung</Link>.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Career Form Script */}
      <script dangerouslySetInnerHTML={{
        __html: `
          document.getElementById('career-form')?.addEventListener('submit', async function(e) {
            e.preventDefault();
            const form = e.target;
            const messageDiv = document.getElementById('career-form-message');
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn.textContent;
            
            // Validate textarea length
            const textarea = form.querySelector('textarea[name="message"]');
            if (textarea.value.length > 500) {
              messageDiv.textContent = 'Die Nachricht darf maximal 500 Zeichen enthalten.';
              messageDiv.className = 'mt-4 text-center text-sm text-red-400 block';
              return;
            }
            
            submitBtn.disabled = true;
            submitBtn.textContent = 'Wird gesendet...';
            messageDiv.className = 'mt-4 text-center text-sm hidden';
            
            try {
              const formData = new FormData(form);
              const response = await fetch(form.action, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData).toString()
              });
              
              if (response.ok) {
                messageDiv.textContent = '✓ Vielen Dank für deine Anfrage! Wir melden uns in Kürze bei dir.';
                messageDiv.className = 'mt-4 text-center text-sm text-teal-400 block';
                form.reset();
              } else {
                throw new Error('Fehler beim Senden');
              }
            } catch (error) {
              messageDiv.textContent = '✗ Fehler beim Senden. Bitte versuche es später erneut.';
              messageDiv.className = 'mt-4 text-center text-sm text-red-400 block';
            } finally {
              submitBtn.disabled = false;
              submitBtn.textContent = originalBtnText;
            }
          });
        `
      }} />

      {/* Contact Form Script */}
      <script dangerouslySetInnerHTML={{
        __html: `
          document.getElementById('contact-form')?.addEventListener('submit', async function(e) {
            e.preventDefault();
            const form = e.target;
            const messageDiv = document.getElementById('form-message');
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn.textContent;
            
            // Validate textarea length
            const textarea = form.querySelector('textarea[name="message"]');
            if (textarea.value.length > 500) {
              messageDiv.textContent = 'Die Nachricht darf maximal 500 Zeichen enthalten.';
              messageDiv.className = 'mt-4 text-center text-sm text-red-400 block';
              return;
            }
            
            submitBtn.disabled = true;
            submitBtn.textContent = 'Wird gesendet...';
            messageDiv.className = 'mt-4 text-center text-sm hidden';
            
            try {
              const formData = new FormData(form);
              const response = await fetch(form.action, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData).toString()
              });
              
              if (response.ok) {
                messageDiv.textContent = '✓ Nachricht erfolgreich gesendet! Wir melden uns bald bei dir.';
                messageDiv.className = 'mt-4 text-center text-sm text-teal-400 block';
                form.reset();
              } else {
                throw new Error('Fehler beim Senden');
              }
            } catch (error) {
              messageDiv.textContent = '✗ Fehler beim Senden. Bitte versuche es später erneut.';
              messageDiv.className = 'mt-4 text-center text-sm text-red-400 block';
            } finally {
              submitBtn.disabled = false;
              submitBtn.textContent = originalBtnText;
            }
          });
        `
      }} />
    </div>
  );
}
